import React from 'react';
import './EventTypeVizCard.scss';

const EventTypeVizCard = ({
  name,
  label,
  defaultLabel,
  description,
  checked,
  onChange,
  preview,
  className,
}) => (
  <label className={`evt-viz-card ${checked ? 'evt-viz-card--selected' : ''} ${className || ''}`}>
    <div className="evt-viz-card__header">
      <div className="evt-viz-dot-container">
          <span 
            className="evt-viz-dot"
            style={{ backgroundColor: checked ? 'var(--blue-lefebvre)' : 'var(--white)' }}
          />
        </div>
      <input
        type="radio"
        name={name}
        checked={checked}
        onChange={onChange}
        className="evt-viz-card__radio"
      />
      <span className="inter-semibold-14 evt-viz-card__label">
        {label}
        {defaultLabel && (
          <span className="evt-viz-card__default"> {defaultLabel}</span>
        )}
      </span>
    </div>
    <p className="inter-regular-14 evt-viz-card__description">{description}</p>
    <div className="evt-viz-card__preview">{preview}</div>
  </label>
);

export default EventTypeVizCard;
